import {
  CartPurchaseRewardPromotionalEvent,
  MarketPromotionalEvent,
  SpecialEditionPromotionalEvent,
} from '@sorare/core/src/__generated__/globalTypes';
import { isType } from '@sorare/core/src/lib/gql';

export const isMarketPromotion = (promotion: {
  __typename: string;
}): promotion is
  | MarketPromotionalEvent
  | SpecialEditionPromotionalEvent
  | CartPurchaseRewardPromotionalEvent => {
  return (
    isType(promotion, 'MarketPromotionalEvent') ||
    isType(promotion, 'SpecialEditionPromotionalEvent') ||
    isType(promotion, 'CartPurchaseRewardPromotionalEvent')
  );
};
